$('.proxy').click(function(e) {
    window.open($(this).find('a').attr('href'),'_self');
    console.log('proxy');
});
$('.proxy-parent').click(function(e) {
    window.open($(this).parent().find('a').attr('href'),'_self');
    console.log('proxy');
});